export default function()
{
    const self = this;

    /**
     * CSS selector of links to an external page
     * @type {String}
     */
    self.externalLinksSelector = '.external-link';

    /**
     * Enable the mechanism for external links
     * @return {void}
     */
    self.enableExternalLinks = () => {
        $('body').on('click', self.externalLinksSelector, event => {
            if (!confirm('Je wordt doorgestuurd naar een andere website, wil je doorgaan?')) {
                event.preventDefault();
            }
        });
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Links.js